import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/mappings`;

export const getMappings = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const createMapping = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateMapping = async (pid, mappingId, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${mappingId}`, data);
};

export const deleteMapping = async (pid, mappingId) => {
  return await axiosInstance.delete(`${BASE(pid)}/${mappingId}`);
};

export const getMappingsByProduct = async (pid, rpid) => {
  return await axiosInstance.get(`${BASE(pid)}/by-product/${rpid}`);
};